import { render, staticRenderFns } from "./traitsTab.vue?vue&type=template&id=5af7dc42&scoped=true&"
import script from "./traitsTab.vue?vue&type=script&lang=js&"
export * from "./traitsTab.vue?vue&type=script&lang=js&"
import style0 from "./traitsTab.vue?vue&type=style&index=0&id=5af7dc42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af7dc42",
  null
  
)

export default component.exports
import {QForm,QScrollArea,QInput,QSelect,QIcon,QPopupProxy,QDate,QCard,QCardSection,QTime} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm,QScrollArea,QInput,QSelect,QIcon,QPopupProxy,QDate,QCard,QCardSection,QTime})
